// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xjFH","label":"styles_label__1NTGZ"};